﻿<template>
    <div class="conf-doc">
        <a :href="document?.url" target="_blank" rel="noopener" class="conf-doc-link">
            <span class="bd-doc-icon" aria-hidden="true">
                <svg viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2" stroke-linecap="round" stroke-linejoin="round"><path d="M14 2H6a2 2 0 0 0-2 2v16a2 2 0 0 0 2 2h12a2 2 0 0 0 2-2V8z" /><path d="M14 2v6h6" /></svg>
            </span>
            <span>
                <strong>{{document?.name}}</strong>
                <small>Open PDF ↗</small>
            </span>
        </a>
        <form class="conf-doc-email print:hidden" @submit.prevent="Email_Document(document?.name ?? '')">
            <label :for="Email_Id()" class="sr-only">Email {{document?.name}} to</label>
            <input :id="Email_Id()" type="email" v-model="email" class="mb-input" placeholder="Email this document to…" autocomplete="email" @input="Sent = false" />
            <button type="submit" class="sm-promo-apply" :disabled="Send_Documents || !Valid_Email()">
                <svg v-if="Send_Documents" class="ts-spinner" viewBox="0 0 24 24" fill="none" aria-hidden="true"><circle cx="12" cy="12" r="10" stroke="currentColor" stroke-width="3" opacity="0.25" /><path d="M22 12a10 10 0 0 0-10-10" stroke="currentColor" stroke-width="3" stroke-linecap="round" /></svg>
                <span v-else>Send</span>
            </button>
        </form>
        <p v-if="Sent" class="sm-promo-msg is-success" role="status">Sent to {{ email }}</p>
        <p v-if="Failed" class="sm-promo-msg is-error" role="alert">Could not send the document. Please try again.</p>
    </div>
</template>

<script lang="ts" src="./documentation_item.ts"></script>